import * as XLSX from 'xlsx';
import { toReadableDate } from '../screens/Machine';
import { calculateTotalPrice } from '../screens/Client';

export const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data.map((item) => ({
        "Equipamento": item.machineInfo.name,
        "Preço por dia": item.pricePerDay,
        "Data Inicio": toReadableDate(item.startedRent),
        "Data Prevista Fim": toReadableDate(item.previsionEndingRent),
        "Data de Fim Real": item.endedRent ? toReadableDate(item.endedRent) : "-",
        "Gerado": calculateTotalPrice(item.pricePerDay, item.startedRent, item.endedRent) + ' €'
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rentings");

    XLSX.writeFile(wb, `${fileName}.xlsx`);
}
export const exportMetricsToExcel = (metrics, mergedMachinesData, fileName) => {
    // Create sheet for Overview Metrics
    const overviewSheet = XLSX.utils.json_to_sheet([
        { metrica: "Total Ganho", valor: `${metrics.totalRevenue}€` },
        { metrica: "Média diaria de ganho", valor: `${metrics?.averageDailyRevenue?.toFixed(2)}€` },
        { metrica: "Numero de Arrendamentos", valor: metrics.numberOfRentals },
        { metrica: "Arrendamentos ativos", valor: metrics.activeRentals },
        { metrica: "Média de duração de arrendamentos", valor: `${metrics?.averageRentalDuration?.toFixed(2)} dias` },
        { metrica: "Arrentamento mais longo", valor: `${metrics.longestRental} dias` },
        { metrica: "Arrendamento mais curto", valor: `${metrics.shortestRental} dias` }
    ], { header: ["metrica", "valor"] });

    // Create sheet for Machine Usage Data
    const machineUsageSheet = XLSX.utils.json_to_sheet(mergedMachinesData.map(machine => ({
        Machine: machine.machine,
        Times_Used: machine.timesUsed,
        Usage_Chances: machine.usageChances,
        Revenue_Since_Started: `${machine.revenueSinceStarted.toFixed(2)}€`,
        Total_Revenue: `${machine.totalRevenue.toFixed(2)}€`
    })));

    // Create a new workbook and add the sheets
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, overviewSheet, "Overview Metrics");
    XLSX.utils.book_append_sheet(wb, machineUsageSheet, "Machine Usage");

    // Write the workbook
    XLSX.writeFile(wb, `${fileName}.xlsx`);
}